module.exports = __webpack_public_path__ + "static/img/funny_10.09385673.jpg";